import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { CoreSharedModule } from '@vendasta/shared';
import { GalaxyFrequencyModule } from '@vendasta/galaxy/frequency';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from '../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../shared/constants';
import { HighlightPricingComponent } from './highlight-pricing/highlight-pricing.component';
import { FormatBillingFrequencyPipe, PricePipe } from './pricing-pipes';
import { VaPricingComponent } from './pricing.component';
import { SimplePriceDisplayComponent } from './simple-price-display.component';
import { StorePriceComponent } from './store-price/store-price.component';
import { TablePricingComponent } from './table-pricing/table-pricing.component';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { FormatDiscountPipe } from '../shared/format-discount.pipe';

@NgModule({
  imports: [
    CommonModule,
    CoreSharedModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatListModule,
    GalaxyPipesModule,
    MatIconModule,
    GalaxyPopoverModule,
    GalaxyFrequencyModule,
    FormatDiscountPipe,
  ],
  declarations: [
    VaPricingComponent,
    HighlightPricingComponent,
    TablePricingComponent,
    StorePriceComponent,
    SimplePriceDisplayComponent,
    PricePipe,
    FormatBillingFrequencyPipe,
  ],
  exports: [
    VaPricingComponent,
    SimplePriceDisplayComponent,
    PricePipe,
    FormatBillingFrequencyPipe,
    StorePriceComponent,
  ],
})
export class VaPricingModule {}
